var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-search"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    clipPath: "url(#clip-search)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21388",
    "data-name": "Path 21388",
    d: "M14.218,12.8,11.151,9.733A6.149,6.149,0,0,0,6.153,0,6.153,6.153,0,0,0,0,6.153a6.145,6.145,0,0,0,9.732,5L12.8,14.218A1,1,0,0,0,14.218,12.8Zm-11-3.715A4.146,4.146,0,1,1,6.153,10.3,4.12,4.12,0,0,1,3.222,9.085Z",
    transform: "translate(3 3)",
    fill: "#c2cce1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3a2cdee20f8d792f549dc212065989ea.svg";
export { ForwardRef as ReactComponent };